var map = {
	"./abandonmentshoppingcart_el.json": "./cloudui/js/models/mosaico/abandonmentshoppingcart_el.json",
	"./abandonmentshoppingcart_en.json": "./cloudui/js/models/mosaico/abandonmentshoppingcart_en.json",
	"./birthday2_el.json": "./cloudui/js/models/mosaico/birthday2_el.json",
	"./birthday2_en.json": "./cloudui/js/models/mosaico/birthday2_en.json",
	"./birthday_el.json": "./cloudui/js/models/mosaico/birthday_el.json",
	"./birthday_en.json": "./cloudui/js/models/mosaico/birthday_en.json",
	"./blackfriday_el.json": "./cloudui/js/models/mosaico/blackfriday_el.json",
	"./blackfriday_en.json": "./cloudui/js/models/mosaico/blackfriday_en.json",
	"./celebration_el.json": "./cloudui/js/models/mosaico/celebration_el.json",
	"./celebration_en.json": "./cloudui/js/models/mosaico/celebration_en.json",
	"./cinema_el.json": "./cloudui/js/models/mosaico/cinema_el.json",
	"./cinema_en.json": "./cloudui/js/models/mosaico/cinema_en.json",
	"./clothesstore_el.json": "./cloudui/js/models/mosaico/clothesstore_el.json",
	"./clothesstore_en.json": "./cloudui/js/models/mosaico/clothesstore_en.json",
	"./cocoonhotel_el.json": "./cloudui/js/models/mosaico/cocoonhotel_el.json",
	"./cocoonhotel_en.json": "./cloudui/js/models/mosaico/cocoonhotel_en.json",
	"./cosmetics_el.json": "./cloudui/js/models/mosaico/cosmetics_el.json",
	"./cosmetics_en.json": "./cloudui/js/models/mosaico/cosmetics_en.json",
	"./easter_el.json": "./cloudui/js/models/mosaico/easter_el.json",
	"./easter_en.json": "./cloudui/js/models/mosaico/easter_en.json",
	"./fitness_el.json": "./cloudui/js/models/mosaico/fitness_el.json",
	"./fitness_en.json": "./cloudui/js/models/mosaico/fitness_en.json",
	"./freetrial_el.json": "./cloudui/js/models/mosaico/freetrial_el.json",
	"./freetrial_en.json": "./cloudui/js/models/mosaico/freetrial_en.json",
	"./gamegiftcard_el.json": "./cloudui/js/models/mosaico/gamegiftcard_el.json",
	"./gamegiftcard_en.json": "./cloudui/js/models/mosaico/gamegiftcard_en.json",
	"./goodmorningcoffee_el.json": "./cloudui/js/models/mosaico/goodmorningcoffee_el.json",
	"./goodmorningcoffee_en.json": "./cloudui/js/models/mosaico/goodmorningcoffee_en.json",
	"./gym_el.json": "./cloudui/js/models/mosaico/gym_el.json",
	"./gym_en.json": "./cloudui/js/models/mosaico/gym_en.json",
	"./hairvoucher_el.json": "./cloudui/js/models/mosaico/hairvoucher_el.json",
	"./hairvoucher_en.json": "./cloudui/js/models/mosaico/hairvoucher_en.json",
	"./hotelbooknow_el.json": "./cloudui/js/models/mosaico/hotelbooknow_el.json",
	"./hotelbooknow_en.json": "./cloudui/js/models/mosaico/hotelbooknow_en.json",
	"./hotelmember_el.json": "./cloudui/js/models/mosaico/hotelmember_el.json",
	"./hotelmember_en.json": "./cloudui/js/models/mosaico/hotelmember_en.json",
	"./loyaltyreward_el.json": "./cloudui/js/models/mosaico/loyaltyreward_el.json",
	"./loyaltyreward_en.json": "./cloudui/js/models/mosaico/loyaltyreward_en.json",
	"./loyaltywelcome_el.json": "./cloudui/js/models/mosaico/loyaltywelcome_el.json",
	"./loyaltywelcome_en.json": "./cloudui/js/models/mosaico/loyaltywelcome_en.json",
	"./masterclass_el.json": "./cloudui/js/models/mosaico/masterclass_el.json",
	"./masterclass_en.json": "./cloudui/js/models/mosaico/masterclass_en.json",
	"./mathcamp_el.json": "./cloudui/js/models/mosaico/mathcamp_el.json",
	"./mathcamp_en.json": "./cloudui/js/models/mosaico/mathcamp_en.json",
	"./medcenter_el.json": "./cloudui/js/models/mosaico/medcenter_el.json",
	"./merrychristmas_el.json": "./cloudui/js/models/mosaico/merrychristmas_el.json",
	"./merrychristmas_en.json": "./cloudui/js/models/mosaico/merrychristmas_en.json",
	"./missyou_el.json": "./cloudui/js/models/mosaico/missyou_el.json",
	"./missyou_en.json": "./cloudui/js/models/mosaico/missyou_en.json",
	"./mobiletv_el.json": "./cloudui/js/models/mosaico/mobiletv_el.json",
	"./mobiletv_en.json": "./cloudui/js/models/mosaico/mobiletv_en.json",
	"./mothersday_el.json": "./cloudui/js/models/mosaico/mothersday_el.json",
	"./mothersday_en.json": "./cloudui/js/models/mosaico/mothersday_en.json",
	"./motorcycleclub_el.json": "./cloudui/js/models/mosaico/motorcycleclub_el.json",
	"./motorcycleclub_en.json": "./cloudui/js/models/mosaico/motorcycleclub_en.json",
	"./newcatalogclothes_el.json": "./cloudui/js/models/mosaico/newcatalogclothes_el.json",
	"./newcatalogclothes_en.json": "./cloudui/js/models/mosaico/newcatalogclothes_en.json",
	"./newcitybar_el.json": "./cloudui/js/models/mosaico/newcitybar_el.json",
	"./newcitybar_en.json": "./cloudui/js/models/mosaico/newcitybar_en.json",
	"./newcollection_el.json": "./cloudui/js/models/mosaico/newcollection_el.json",
	"./newcollection_en.json": "./cloudui/js/models/mosaico/newcollection_en.json",
	"./newmenu_el.json": "./cloudui/js/models/mosaico/newmenu_el.json",
	"./newmenu_en.json": "./cloudui/js/models/mosaico/newmenu_en.json",
	"./newrestaurant_el.json": "./cloudui/js/models/mosaico/newrestaurant_el.json",
	"./newrestaurant_en.json": "./cloudui/js/models/mosaico/newrestaurant_en.json",
	"./newsletter_el.json": "./cloudui/js/models/mosaico/newsletter_el.json",
	"./newsletter_en.json": "./cloudui/js/models/mosaico/newsletter_en.json",
	"./notification_el.json": "./cloudui/js/models/mosaico/notification_el.json",
	"./notification_en.json": "./cloudui/js/models/mosaico/notification_en.json",
	"./oneCol.json": "./cloudui/js/models/mosaico/oneCol.json",
	"./perfume_el.json": "./cloudui/js/models/mosaico/perfume_el.json",
	"./perfume_en.json": "./cloudui/js/models/mosaico/perfume_en.json",
	"./pharmacy_el.json": "./cloudui/js/models/mosaico/pharmacy_el.json",
	"./pharmacy_en.json": "./cloudui/js/models/mosaico/pharmacy_en.json",
	"./playfestival_el.json": "./cloudui/js/models/mosaico/playfestival_el.json",
	"./playfestival_en.json": "./cloudui/js/models/mosaico/playfestival_en.json",
	"./reengage_el.json": "./cloudui/js/models/mosaico/reengage_el.json",
	"./reengage_en.json": "./cloudui/js/models/mosaico/reengage_en.json",
	"./restaurantcoupon_el.json": "./cloudui/js/models/mosaico/restaurantcoupon_el.json",
	"./restaurantcoupon_en.json": "./cloudui/js/models/mosaico/restaurantcoupon_en.json",
	"./sales_el.json": "./cloudui/js/models/mosaico/sales_el.json",
	"./sales_en.json": "./cloudui/js/models/mosaico/sales_en.json",
	"./salonspa_el.json": "./cloudui/js/models/mosaico/salonspa_el.json",
	"./salonspa_en.json": "./cloudui/js/models/mosaico/salonspa_en.json",
	"./thankyou_el.json": "./cloudui/js/models/mosaico/thankyou_el.json",
	"./thankyou_en.json": "./cloudui/js/models/mosaico/thankyou_en.json",
	"./threeCol.json": "./cloudui/js/models/mosaico/threeCol.json",
	"./travel_el.json": "./cloudui/js/models/mosaico/travel_el.json",
	"./travel_en.json": "./cloudui/js/models/mosaico/travel_en.json",
	"./travelagency_el.json": "./cloudui/js/models/mosaico/travelagency_el.json",
	"./travelagency_en.json": "./cloudui/js/models/mosaico/travelagency_en.json",
	"./twoCol.json": "./cloudui/js/models/mosaico/twoCol.json",
	"./valentinesshopping_el.json": "./cloudui/js/models/mosaico/valentinesshopping_el.json",
	"./valentinesshopping_en.json": "./cloudui/js/models/mosaico/valentinesshopping_en.json",
	"./watersports_el.json": "./cloudui/js/models/mosaico/watersports_el.json",
	"./watersports_en.json": "./cloudui/js/models/mosaico/watersports_en.json",
	"./welcome_el.json": "./cloudui/js/models/mosaico/welcome_el.json",
	"./welcome_en.json": "./cloudui/js/models/mosaico/welcome_en.json",
	"./welcomefashionshop_el.json": "./cloudui/js/models/mosaico/welcomefashionshop_el.json",
	"./welcomefashionshop_en.json": "./cloudui/js/models/mosaico/welcomefashionshop_en.json",
	"./winetasting_el.json": "./cloudui/js/models/mosaico/winetasting_el.json",
	"./winetasting_en.json": "./cloudui/js/models/mosaico/winetasting_en.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./cloudui/js/models/mosaico sync recursive ^\\.\\/.*\\.json$";